import { Icon, IconName, Stack, Text } from '@hotjar/hotsauce';
import { ListItemContainer, ListItemHeader, ListItemTitle } from './ListItem.styles';
import { ReactElement } from 'react';

export function ListItem({
  icon,
  title,
  description,
  actions,
  textType,
}: {
  title: string | ReactElement;
  icon?: IconName;
  description?: ReactElement;
  actions?: JSX.Element | Array<JSX.Element>;
  textType?: 'subtitle1' | 'body1';
}) {
  return (
    <ListItemContainer direction="column">
      <ListItemHeader>
        <ListItemTitle>
          {icon && <Icon icon={icon} />}
          <Text textType={textType ?? 'subtitle1'}>{title}</Text>
        </ListItemTitle>
        {actions && <div>{actions}</div>}
      </ListItemHeader>
      {description && <Stack direction="column">{description}</Stack>}
    </ListItemContainer>
  );
}
